export default {
  methods: {
    getSalutation(person) {
      // if salutation is not Unknown.
      if (person.salutation_id && person.salutation_id !== 16) {
        let salutation = person.salutation.name;
        if (person.salutation_id !== 2) {
          salutation = `${salutation}.`;
        }
        return salutation;
      }
      return null;
    },
  },
};
